// extracted by mini-css-extract-plugin
export default {"delete-account":"delete-account--bqXhF"};
    if(module.hot) {
      // 1747648148922
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  